var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.71 4.04a.65.65 0 0 1 0 .92L6.668 8l3.04 3.04a.65.65 0 1 1-.919.92l-3.5-3.5a.65.65 0 0 1 0-.92l3.5-3.5a.65.65 0 0 1 .92 0Z",
    fill: "currentColor"
  })));
};
export default SvgChevronLeft;